import React, { Component } from 'react';
import Slider from 'react-slick';
import { LazyImg } from './LazyImg';
import { uCommerce } from '../utils/projectImages';
import { ArrowBackIcon, ArrowForwardIcon } from '@chakra-ui/icons';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Reveal from './Reveal';

const CustomNext = ({ style, onClick }) => {
  return (
    <div
      style={{
        ...style,
        display: 'block',
        position: 'absolute',
        right: 15,
        top: '40%',
        bottom: '60%',
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      <ArrowForwardIcon
        w={12}
        h={12}
        color="white"
        backgroundColor="rgba(0,0,0,0.6)"
        p={2}
        borderRadius="50%"
        borderWidth="4px"
        borderColor="transparent"
        transition=".1s linear"
        _hover={{
          borderColor: 'blue.200',
        }}
      />
    </div>
  );
};

const CustomPrev = ({ style, onClick }) => {
  return (
    <div
      style={{
        ...style,
        display: 'block',
        position: 'absolute',
        left: 15,
        top: '40%',
        bottom: '60%',
        cursor: 'pointer',
        zIndex: 10,
      }}
      onClick={onClick}
    >
      <ArrowBackIcon
        w={12}
        h={12}
        color="white"
        backgroundColor="rgba(0,0,0,0.6)"
        p={2}
        borderRadius="50%"
        borderWidth="4px"
        borderColor="transparent"
        transition=".1s linear"
        _hover={{
          borderColor: 'blue.200',
        }}
      />
    </div>
  );
};

const CovidTrackerSlideShow = ({ setSelectedImg }) => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    nextArrow: <CustomNext />,
    prevArrow: <CustomPrev />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };
  return (
    <Reveal>
      <Slider {...settings}>
        {uCommerce.map(({ title, image }) => {
          return (
            <>
              <LazyImg
                image={image}
                title={title}
                setSelectedImg={setSelectedImg}
              />
            </>
          );
        })}
      </Slider>
    </Reveal>
  );
};

export default CovidTrackerSlideShow;
